import React, { Component, MouseEvent, ChangeEvent } from "react";
import morning from "./Image(1683746016937).jpeg";
import seasons from "./istockphoto-531535355-612x612.jpg";
import friday from "./depositphotos_36347863-stock-photo-friday-concept.jpg"
import exercise from "./GRT-weight-dumbbell-732x549-thumb-732x549.jpg"

type QuizPageProps = {
    onFinishClick: (score: number[]) => void;
};

type QuizPageState = {
    score: number[];
};

export class QuizPage extends Component<QuizPageProps, QuizPageState> {

    constructor(props: QuizPageProps) {
        super(props);

        this.state = {
            score: [0, 0]
        };
    }
    
    render = (): JSX.Element => {
        return (
            <div>
                <div className="Q1">
                    <h3>When do you normally wake up?</h3>
                    <p>
                    <img src={morning} className="morning" alt="morning"/>
                    </p>
                    <label>
                    <input type="radio" name="q1" onChange={this.doDogClick}/>
                    I like to sleep in (10 or later)
                    </label>
                    <label>
                    <input type="radio" name="q1" onChange={this.doCatClick}/>
                    I like to get an early start (7-8)
                    </label>
                    <p></p>
                    <label>
                    <input type="radio" name="q1" onChange={this.doCatClick}/>
                    I am up with the sun (5-7)
                    </label>
                    <label>
                    <input type="radio" name="q1" onChange={this.doDogClick}/>
                    I wake up between 8 and 9
                    </label>
                </div>

                <div className="Q2">
                    <h3>Favorite Season?</h3>
                    <p>
                    <img src={seasons} className="seasons" alt="seasons"/>
                    </p>
                    <label>
                    <input type="radio" name="q2" onChange={this.doDogClick}/>
                    Spring
                    </label>
                    <label>
                    <input type="radio" name="q2" onChange={this.doDogClick}/>
                    Summer
                    </label>
                    <p></p>
                    <label>
                    <input type="radio" name="q2" onChange={this.doCatClick}/>
                    Autumn
                    </label>
                    <label>
                    <input type="radio" name="q2" onChange={this.doCatClick}/>
                    Winter
                    </label>
                </div>

                <div className="Q3">
                    <h3>What are you doing on a friday night?</h3>
                    <p>
                    <img src={friday} className="friday" alt="friday"/>
                    </p>
                    <label>
                    <input type="radio" name="q3" onChange={this.doDogClick}/>
                    I'm out somewhere with friends
                    </label>
                    <label>
                    <input type="radio" name="q3" onChange={this.doCatClick}/>
                    I'm reading in bed
                    </label>
                    <p></p>
                    <label>
                    <input type="radio" name="q3" onChange={this.doDogClick}/>
                    At a family dinner
                    </label>
                    <label>
                    <input type="radio" name="q3" onChange={this.doCatClick}/>
                    Watching a movie at home with a close friend
                    </label>
                </div>

                <div className="Q4">
                    <h3>Favorite form of exercise?</h3>
                    <p>
                    <img src={exercise} className="exercise" alt="exercise"/>
                    </p>
                    <label>
                    <input type="radio" name="q4" onChange={this.doDogClick}/>
                    I love to play sports
                    </label>
                    <label>
                    <input type="radio" name="q4" onChange={this.doCatClick}/>
                    I like doing yoga
                    </label>
                    <p></p>
                    <label>
                    <input type="radio" name="q4" onChange={this.doDogClick}/>
                    Going on runs
                    </label>
                    <label>
                    <input type="radio" name="q4" onChange={this.doCatClick}/>
                    Climbing things
                    </label>
                </div>

                <p></p>


                <button onClick={this.doFinishClick}>Finish</button>
            </div>
        )
    }

    doCatClick = (_evt: ChangeEvent<HTMLInputElement>): void => {
        this.setState({score: [this.state.score[0] + 1, this.state.score[1]]});
    }

    doDogClick = (_evt: ChangeEvent<HTMLInputElement>): void => {
        this.setState({score: [this.state.score[0], this.state.score[1] + 1]});
    }

    doFinishClick = (_evt: MouseEvent<HTMLButtonElement>): void => {
        this.props.onFinishClick(this.state.score);
    }
}